export const EN1 = [
    "No experience",
    "Beginner",
    "Basic experience",
    "Experienced",
    "Expert"
];

export const EN2 = [
    "No experience (DEEPSEA, COMAP, DEIF, ETC.)",
    "Beginner (DEEPSEA, COMAP, DEIF, ETC.)",
    "Basic experience (DEEPSEA, COMAP, DEIF, ETC.)",
    "Experienced (DEEPSEA, COMAP, DEIF, ETC.)",
    "Expert (DEEPSEA, COMAP, DEIF, ETC.)"
];

export const EN3 = [
    "No experience (BASLER, UNITROL, ETC.)",
    "Beginner (BASLER, UNITROL, ETC.)",
    "Basic experience (BASLER, UNITROL, ETC.)",
    "Experienced (BASLER, UNITROL, ETC.)",
    "Expert (BASLER, UNITROL, ETC.)"
];

export const EN4 = [
    "Yes",
    "No",
    "Outsource"
];

export const EN5 = [
    "Up to 200 kva",
    "Up to 500 kva",
    "Up to 1000 kva",
    "Up to 1500 kva",
    "Up to 2000 kva",
    "Up to 2500 kva",
    "Up to 3000 kva",
    "No limit"
];

export const EN6 = [
    "No service on site",
    "Up to 500 km",
    "Up to 1000 km",
    "Over 1000 km (no limit)"
];

export const EN7 = [
    "None",
    "Yes from 1 to 5",
    "Yes from 6 to 10",
    "Yes more than 10"
];

export const EN8 = [
    "Yes",
    "No"
];

export const EN9 = [
    "Yes with laser",
    "Yes with dial gauge",
    "Yes with other tool",
    "No"
];
export const EN10 = [
    "Yes service confirmed",
    "Not available"
];

export const EN11 = [
    "Approved",
    "Not approved"
];


export const EN12 = [
    "Null",
    "Poor",
    "Basic",
    "Good",
    "Excellent"
];

export const EN13 = [
    "Service",
    "Meccalte"
];

export const ENArea = [
    "Europe - Italy",
    "Europe - Spain",
    "Europe - UK/EIRE",
    "Europe - Germany",
    "Europe - France",
    "Europe - Russia",
    "Europe - Other Countries",
    "Africa",
    "North America",
    "Central America",
    "South America",
    "Middle East",
    "Far East - India",
    "Far East"
]


export const ENNotes = [
    "The button on the right automatically fills the field based on the information listed above. If this information is  not recognized, manually enter the coordinates, latitude and longitude, separated by a comma <br> (example: 45.6515661 , 11.8564252, then latitude then a space, then a comma, then a space and finally the longitude).",
    "Technical people, engineers for intervention on site",
    "Subsidiary situation, fill an additional SPQ questionnaire for each facility/subsidiary",
    "Approximate number of workshop repairs and onsite interventions carried out for Mecc Alte",
    "Number of workshop repairs and onsite interventions carried out for meccalte in the last 12 months, specify the period",
    "Standard hourly rate for workshop activity",
    "Standard hourly rate for on-site activity",
    "Audit/visit date; specify meccalte visitors",
    "Comment on possible competitions with other alternator manufacturers",
    "Comment on possible competitions with other genset manufacturers",
    "Select level about exhaustive reporting and good communication attitude",
    "Select approval status, authorized status"
];